"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _legacy = require("vue-google-charts/legacy");
var _leads = require("@/api/leads");
var _utils = require("@/utils");
var _moment = _interopRequireDefault(require("moment"));
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.list = [];
    this.startDate = '';
    this.endDate = '';
    this.chartData = [['Day', 'New', 'Won', 'Lost', {
      role: 'annotation'
    }]
    // ['Sat', 10, 24, 20, ''],
    // ['Sun', 16, 22, 23, ''],
    // ['Mon', 28, 19, 29, '']
    ];
    this.chartOptions = {
      height: 220,
      chartArea: {
        top: 40,
        width: '85%',
        height: '75%'
      },
      bar: {
        groupWidth: '30%'
      },
      legend: {
        position: 'top'
      },
      colors: ['#fac858', '#91cc75', '#f85d5d'],
      backgroundColor: {
        fill: 'none'
      },
      fontName: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif',
      fontSize: 10
      // isStacked: true
    };
  }
  created() {
    const date = new Date();
    this.endDate = date.toISOString();
    date.setDate(date.getDate() - 6);
    this.startDate = date.toISOString();
    this.fetchData();
  }
  async fetchData() {
    const query = {
      enabled: true,
      createdTimestamp: [this.startDate, this.endDate],
      status: 'New',
      filter: {
        enabled: '$eq',
        status: '$eq',
        createdTimestamp: '$between'
      }
    };
    const daysOfWeek = {
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday'
    };
    const response = await (0, _leads.getLeadsBarGraphData)((0, _utils.getQuery)({
      startDate: this.startDate,
      endDate: this.endDate
    }));
    response.forEach(item => {
      const row = Object.values(item);
      row[0] = daysOfWeek[(0, _moment.default)(row[0]).day()];
      row[1] = +row[1];
      row[2] = +row[2];
      row[3] = +row[3];
      row.push('');
      this.chartData.push(row);
    });
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ''
})], default_1.prototype, "dateRange", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LeadBarChart',
  components: {
    GChart: _legacy.GChart
  }
})], default_1);
var _default = exports.default = default_1;